import { UIStore } from '../ui/ui-store';

export class ToggleShowArticleCommentsAction {
  async toggleShowArticleComments(this: UIStore): Promise<void> {
    this.showArticleComments = !this.showArticleComments;
    localStorage.setItem('showArticleComments', this.showArticleComments.toString());
  }
}
